// extracted by mini-css-extract-plugin
export default {"root":"OHPSkS","overlay":"xUQD7o","showOverlayOnHover":"FRoIWK","leftCorner":"jsd9or","center":"HJXwdZ","image":"pVRFqP","live":"tkMIXY","header":"fxXBgd","currency":"vSMONB"};